import { getAPIPath } from '@interhyp/platform-request';
import 'regenerator-runtime';
import { apm, init as initApm } from '@elastic/apm-rum';
import { ErrorBoundary } from '@interhyp/util-react-errors';
import { TranslationContextProvider } from '@interhyp/util-translation';
import Axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import { App } from './components/app/App';
import { extensions } from './constants/module';

import { PluginProvider } from '@interhyp/platform-module';
import { useBaseUploadCenter } from '@interhyp/module-documents';

let environment = window.process.env.APP_ENV ?? 'local';
environment = environment === '##APP_ENV##' ? 'local' : environment;

initApm({
  serviceName: 'app-ehyp-credit',
  serverUrl: `${getAPIPath('apm')}`,
  serviceVersion: process.env.APP_VERSION,
  logLevel: 'info',
  active: environment !== 'ci' && environment !== 'local',
  environment,
  instrument: true,
});

export function Application(): JSX.Element {
  useBaseUploadCenter();
  const [isAuth, setIsAuth] = useState(false);
  const interval = useRef<any>();

  const heartbeat = useCallback(async () => {
    try {
      await Axios.get(`${getAPIPath('credit-decision-portal-adapter')}/authentication/refresh`, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
        },
      });
      setIsAuth(true);
    } catch (error) {
      clearInterval(interval.current);
      window.location.replace(`/authorizations/banker/login`);
      apm.captureError(
        `token could not be refreshed traceId: ${JSON.stringify(error?.response?.data?.traceId)}`,
      );
      setIsAuth(false);
      return false;
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('easyAccessCallbackPath', window.location.pathname);
    heartbeat();

    interval.current = setInterval(() => {
      heartbeat();
    }, 240_000); // 4 minutes
    return () => clearInterval(interval.current);
  }, [heartbeat]);

  return (
    <ErrorBoundary moduleName="app-ehyp-credit">
      <TranslationContextProvider>
        <BrowserRouter>
          <PluginProvider extensions={extensions}>
            <CompatRouter>{isAuth && <App />}</CompatRouter>
          </PluginProvider>
        </BrowserRouter>
      </TranslationContextProvider>
    </ErrorBoundary>
  );
}
